import { cn } from "@/lib/utils";

export const Logo = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "shrink-0 bg-none p-1 rounded-md flex items-center justify-center",
        className,
      )}
    >
      <img
        src="/logo-full.png"
        alt="MindMyJob Logo"
        className="h-10 sm:h-8 object-contain"
      />
    </div>
  );
};
